// src/hooks/useGlobalCall.js
import { useRef } from "react";

// Ref globale pour stocker startCall
const startCallRef = { current: null };
export const useGlobalCall = () => startCallRef;
